import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-marketplace-shopping-cart-featured',
  templateUrl: './cv-marketplace-shopping-cart-featured.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-featured.component.scss']
})
export class CvMarketplaceShoppingCartFeaturedComponent implements OnInit, OnDestroy {

  @Output() clearSearch = new EventEmitter<string>();
  @Output() showValidationMsg = new EventEmitter<any>();
  pscs = null;
  localizationStrings = new Map();

  cardWidth: string = '0%';
  @ViewChild('featuredContainer') featuredContainerER: ElementRef;
  featuredContainerWidth: number = 0;
  featuredContainerWidthObserver :any = null;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    private changeDetector?: ChangeDetectorRef,
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
  }

  ngOnInit(): void {
    this.setCardsWidth(true);
    this.pscs.shoppingCartActiveTab = 'HOME';
    setTimeout(() => {
      this.pscs.shoppingCartIsProductSelected = false;
    }, 0);
    this.clearSearch.emit();
    this.loadLocalizations();
  }

  ngOnDestroy(): void {
    if (this.featuredContainerWidthObserver) {
      this.featuredContainerWidthObserver.disconnect();
    }
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this.localizationStrings = map;
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

  getImagesCount(product) {
    let count = 0;
    if (product.MultipleImagesData != null && product.MultipleImagesData.length > 1) {
      let mainImages = product.MultipleImagesData.filter((i) => { return i.PointStoreProductVariationID == null || i.PointStoreProductVariationID == 0; });
      count = mainImages != null ? mainImages.length : 0;

      if (product.VariationsData != null && product.VariationsData.length > 0) {
        let variationImages = product.VariationsData.map((v) => {
          if (v.Active == null || v.Active)
            return v.PointStoreProductVariationID;
        });
        product.MultipleImagesData.forEach((currentValue, index, array) => {
          if (variationImages.includes(currentValue.PointStoreProductVariationID))
            count++;
        });
      }
      return count - 1;
    } else {
      return 1
    }
  }

  isCurrentSale(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }

    return false;
  }

  isFeatured(item: any): boolean {
    if (typeof item !== 'undefined' && item != null) {
      return this.shoppingCartService.filterCollectionsByType(item, 2);
    }

    return false;
  }

  getProductPrices(product) {
    if (product != null) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return product.CalculatedRealPrice;
      } else
        return product.Price;
    }
  }

  filterFeaturedProducts(items) {
    if(items.length > 0){
      let itemsCloned = Object.assign([], items);
      itemsCloned.splice(this.calculateQuantityOfCards(), itemsCloned.length - 1);
      return itemsCloned;
    } else {
      return [];
    }
  }

  isPriceLabelTooLong(product) {
    let value = String(this.getProductPrices(product));
    if (value.includes("-")) {
      return value.length > 11;
    } else {
      return new CvNumberLocalizePipe().transform(value).length > 6 && product.Sale != null && this.isCurrentSale(product);
    }
  }

  isOutOfStock(product): any {
    if (product != null) {
      if (product.HasProductVariations && product.VariationsData != null && product.VariationsData.length > 0) {
        let variationsOutOfStock = 0;
        product.VariationsData.forEach(variation => {
          if (variation.VariationQuantity === 0)
            variationsOutOfStock++;
        });
        return variationsOutOfStock == product.VariationsData.length;
      } else {
        return product.Quantity == 0 || product.Quantity < 0;
      }
    } else
      return false;
  }

  openProductDetails(product) {
    this.pscs.shoppingCartIsProductSelected = true;
    this.pscs.pointStoreDetailedViewProduct = product;
  }

  wishlistAction(product, $event) {
    $event.stopPropagation();
    if (product.isInWhisList)
      this.removeFromWishlist(product)
    else
      this.addToWishlistProduct(product);
  }

  async removeFromWishlist(product) {
    let response = await this.shoppingCartService.removeWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: false });
  }

  async addToWishlistProduct(product) {
    let response = await this.shoppingCartService.addWishlistItem(product);
    if (response)
      this.showValidationMsg.emit({ event: event, isAdding: true });
  }
  
  isMainImageEmptyWithMultiplesImages(product): boolean{
    let status = false;
    if(product.HasMultipleImages && (product.ProductImageID == 0 || product.ProductImageID == null))
    {
      status = true;
    } else {
      status = false;
    }
    return status;
  }

  getFirstVariationImage(product: any): any {
    let firstVariationImage;
    if(product && product.MultipleImagesData && product.MultipleImagesData.length > 0){
      firstVariationImage = product.MultipleImagesData[0].PointStoreProductImageID;
    }
    return firstVariationImage;
  }
  
  reduceLongPriceLength(longPrice: string): string{
    if (longPrice.length > 19){
      return (longPrice.substring(0, 17) + "...");
    } else{
      return longPrice;
    }
  }

  /**
 * calculate card width based on the content size.
 */
  calculateCardsWidth() {
    const upperTabsContent = document.getElementsByClassName('upper-tabs-content');
    if (upperTabsContent) {
      const elementFromUpperTabsContent = upperTabsContent[0] as HTMLElement;
      if (elementFromUpperTabsContent.offsetWidth >= 1770) {
        //7 cards by row
        this.cardWidth = '14.28571428571429%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1769 && elementFromUpperTabsContent.offsetWidth >= 1470) {
        //6 cards by row
        this.cardWidth = '16.66666666666667%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1469 && elementFromUpperTabsContent.offsetWidth >= 1270) {
        //5 cards by row
        this.cardWidth = '20%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1269 && elementFromUpperTabsContent.offsetWidth >= 1070) {
        //4 cards by row
        this.cardWidth = '25%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1069 && elementFromUpperTabsContent.offsetWidth >= 830) {
        //3 cards by row
        this.cardWidth = '33.33%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 829 && elementFromUpperTabsContent.offsetWidth >= 600) {
        //2 cards by row
        this.cardWidth = '50%';
      } else {
        //1 card by row
        this.cardWidth = '100%';
      }
    } else {
      this.cardWidth = '20%';
    }
  }

  /**
* set the card width based on the width of 'upper-tabs-content', Use the calculateCardsWidth() function
*/
  setCardsWidth(firstLoading: boolean): void {
    this.calculateCardsWidth();
    this.changeDetector.detectChanges();
    if (firstLoading) {
      setTimeout(() => {
        this.configureCardsWidth();
        this.configureResizeObserver();
      }, 0);
    } else {
      this.configureCardsWidth();
    }
  }

  /**
 * configure the featuredContainerWidth variable. 
 */
  configureCardsWidth() {
    if (this.featuredContainerER) {
      this.featuredContainerWidth = this.featuredContainerER.nativeElement.offsetWidth;
    } else {
      this.featuredContainerWidth = 1;
    }
  }

  /**
   * configure resize observer
   */
  configureResizeObserver() {
    this.featuredContainerWidthObserver = new ResizeObserver(entries => {
      if (this.featuredContainerER) {
        // Adjust the width of the card according to the width of the container.
        if (this.featuredContainerER.nativeElement.offsetWidth !== 0 &&
          this.featuredContainerWidth !== 0 &&
          this.featuredContainerER.nativeElement.offsetWidth !== this.featuredContainerWidth) {
          this.setCardsWidth(false);
        }
      }
    });
    const divToObserve = document.getElementById('featured-container');
    this.featuredContainerWidthObserver.observe(divToObserve);
  }


  /**
* calculate the quantity of cards to show in the feature content.
*/
  calculateQuantityOfCards(): number {
    let quantityOfCards: number = 0;
    const upperTabsContent = document.getElementsByClassName('upper-tabs-content');
    if (upperTabsContent) {
      const elementFromUpperTabsContent = upperTabsContent[0] as HTMLElement;
      if (elementFromUpperTabsContent.offsetWidth >= 1770) {
        quantityOfCards = 7;
      } else if (elementFromUpperTabsContent.offsetWidth <= 1769 && elementFromUpperTabsContent.offsetWidth >= 1470) {
        quantityOfCards = 6;
      } else if (elementFromUpperTabsContent.offsetWidth <= 1469 && elementFromUpperTabsContent.offsetWidth >= 1270) {
        quantityOfCards = 5;
      } else if (elementFromUpperTabsContent.offsetWidth <= 1269 && elementFromUpperTabsContent.offsetWidth >= 1070) {
        quantityOfCards = 4;
      } else if (elementFromUpperTabsContent.offsetWidth <= 1069 && elementFromUpperTabsContent.offsetWidth >= 830) {
        quantityOfCards = 3;
      } else if (elementFromUpperTabsContent.offsetWidth <= 829 && elementFromUpperTabsContent.offsetWidth >= 600) {
        quantityOfCards = 2;
      } else {
        quantityOfCards = 1;
      }
    } else {
      quantityOfCards = 5;
    }
    return quantityOfCards;
  }
}
